enum ProjectRole {
  OWNER = "198",
  PROJECT_MANAGER = "201",
  WORKER = "202",
  VIEWER = "203",
}

export { ProjectRole };
